// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__3DEjr","content":"error_content__3Cjlm","errorImage":"error_errorImage__3j54S","error_text":"error_error_text__mN3Pg","button":"error_button__10FZx"};